var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tel-input',_vm._b({ref:"tel-input",attrs:{"disabledFetchingCountry":true,"value":_vm.value,"required":_vm.required,"data-selected":_vm.value},on:{"input":_vm.handleInput}},'vue-tel-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }